// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__uwaOg","input":"styles_input__28xzG"};